// function updateTotalElement(total) {
//   const totalElems = document.querySelectorAll('.total-pack_summary');
//   totalElems.forEach(elem => {
//     if (elem.tagName === 'INPUT') {
//       elem.value = total;
//     } else {
//       elem.textContent = total;
//     }
//   });
// }

// function updateTotal() {
//   const packInput = document.querySelector('input.product-pack-of-value');
//   const quantityInput = document.querySelector('input[name="quantity"]');
//   const totalElem = document.querySelector('.total-pack_summary');
//   const selectedVariantId = document.querySelector('[name="id"]')?.value;
//   if (selectedVariantId && window.variantPackOf[selectedVariantId]) {
//     packInput.value = window.variantPackOf[selectedVariantId];
//   }
//   const packValue = parseFloat(packInput?.value) || 0;
//   const quantity = parseFloat(quantityInput?.value) || 0;
//   const total = packValue * quantity;
//   updateTotalElement(total);

//   const summaryQtyElem = document.querySelector('.pricing-summary-table .summary-qty');
//   if (summaryQtyElem) summaryQtyElem.textContent = packInput.value;
// }

// document.addEventListener('variant:change', function() {
//   updateTotal();
// });

// function updateVariantTitle(variantValue) {
//   const summaryElem = document.querySelector('.summaryVariant_title');
//   if (summaryElem) summaryElem.textContent = variantValue;
// }

// function attachVariantListeners() {
//   const radios = document.querySelectorAll('variant-selects [type="radio"]');
//   radios.forEach(radio => {
//     radio.removeEventListener('change', onVariantChange);
//     radio.addEventListener('change', onVariantChange);
//   });

//   const checkedRadio = document.querySelector('variant-selects [type="radio"]:checked');
//   if (checkedRadio) updateVariantTitle(checkedRadio.value);

//   const inputs = document.querySelectorAll('input.product-pack-of-value, input[name="quantity"]');
//   inputs.forEach(input => {
//     input.removeEventListener('input', updateTotal);
//     input.removeEventListener('change', updateTotal);
//     input.addEventListener('input', updateTotal);
//     input.addEventListener('change', updateTotal);
//   });

//   updateTotal();

//   document.querySelectorAll('.oscpAccordionContainer .inrvriantgrdCol span, .f-price-item, .f-price-item s, .summaryVariant_price').forEach(el => {
//     el.textContent = el.textContent.replace(/excl\.?\s*VAT/gi, '').trim();
//   });
// }

// function onVariantChange(e) {
//   updateVariantTitle(e.target.value);
//   updateTotal();
// }

// attachVariantListeners();
// document.addEventListener('cpw:price-grid-switch', attachVariantListeners);

// document.addEventListener("DOMContentLoaded", function () {
//   function updateSummaryPrice() {
//     const activeLi = document.querySelector('input[name="oscpBuyQty"]:checked')?.closest('li');
//     if (!activeLi) return;

//     const priceText = activeLi.querySelector('.oscGrdelm.stv')?.textContent.replace(/[^\d.]/g, '') || '0';
//     // .oscp-price-grid-discounted
//     const price = parseFloat(priceText) || 0;

//     const quantityInput = document.querySelector('input[name="quantity"]');
//     const quantity = parseFloat(quantityInput?.value) || 1;

//     const total = price * quantity;
    
//     let currencySymbol = '£';
//     if (window.Shopify && Shopify.currency) {
//       if (Shopify.currency.symbol) {
//         currencySymbol = Shopify.currency.symbol;
//       } else if (Shopify.currency.active === 'USD') {
//         currencySymbol = '$';
//       }
//     }
    
//     document.querySelectorAll('.summaryVariant_price').forEach(el => {
//       el.textContent = currencySymbol + total.toFixed(2);
//     });

//     document.querySelectorAll(
//       '.product__info-container .f-price__sale .f-price-item.f-price-item--sale, ' +
//       'sticky-atc-bar .f-price-item.f-price-item--sale, ' +
//       '.product__info-container .f-price__regular .f-price-item--regular, ' +
//       'sticky-atc-bar .f-price__regular .f-price-item--regular'
//     ).forEach(el => {
//       el.textContent = currencySymbol + total.toFixed(2);
//     });

//     if (typeof updateTotal === "function") {
//       updateTotal();
//     }
//   }

//   document.addEventListener("click", function (e) {
//     if (e.target.closest(".oscpPriceGrid li")) {
//       // .oscp-price-grid-list li
//       setTimeout(updateSummaryPrice, 600);
//     }
//   });

//   document.addEventListener("input", function (e) {
//     if (e.target.matches('input[name="quantity"]')) {
//       updateSummaryPrice();
//     }
//   });

//   document.addEventListener("change", function (e) {
//     if (e.target.matches('input[name="quantity"]')) {
//       updateSummaryPrice();
//     }
//   });

//   updateSummaryPrice();
// });

// // document.addEventListener("DOMContentLoaded", function () {
// //   document.addEventListener("change", function (e) {
// //     if (e.target && e.target.name === "updates[]") {
// //       const input = e.target;
// //       const cartItem = input.closest(".cart-item");

// //       if (!cartItem) return;

// //       const variantId = cartItem.dataset.variantId;
// //       const baseBags = parseInt(cartItem.dataset.totalBags) || 100;
// //       const quantity = parseInt(input.value) || 0;
// //       const total = baseBags * quantity;

// //       console.log(`Variant ${variantId}: ${quantity} × ${baseBags} = ${total} bags`);

// //       fetch(`/cart/change.js`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({
// //           id: variantId,
// //           quantity: quantity,
// //           properties: {
// //             "Total Bags": total.toString()
// //           }
// //         })
// //       })
// //         .then((res) => res.json())
// //         .then((data) => console.log("Cart updated:", data))
// //         .catch((err) => console.error("Error:", err));
// //     }
// //   });
// // });




// The sticky ATC bar renders its own <input name="quantity"> (and even reuses
// the main form's id), so any unscoped `input[name="quantity"]` lookup can grab
// the wrong one depending on DOM order. Always exclude the sticky bar's copy.
function getMainQuantityInput() {
  const inputs = document.querySelectorAll('input[name="quantity"]');
  return Array.from(inputs).find(el => !el.closest('.sticky-atc-bar')) || inputs[0];
}

function getSelectedVariantId() {
  const idInputs = document.querySelectorAll('[name="id"]');
  const idInput = Array.from(idInputs).find(el => !el.closest('.sticky-atc-bar'));
  return (idInput || idInputs[0])?.value;
}

function updateTotalElement(total) {
  const totalElems = document.querySelectorAll('.total-pack_summary');
  totalElems.forEach(elem => {
    if (elem.tagName === 'INPUT') {
      elem.value = total;
    } else {
      elem.textContent = total;
    }
  });
}

function updateTotal() {
  const packInput = document.querySelector('input.product-pack-of-value');
  const quantityInput = getMainQuantityInput();
  const totalElem = document.querySelector('.total-pack_summary');
  const selectedVariantId = getSelectedVariantId();
  if (selectedVariantId && window.variantPackOf[selectedVariantId]) {
    packInput.value = window.variantPackOf[selectedVariantId];
  }
  const packValue = parseFloat(packInput?.value) || 0;
  const quantity = parseFloat(quantityInput?.value) || 0;
  const total = packValue * quantity;
  updateTotalElement(total);

  const summaryQtyElem = document.querySelector('.pricing-summary-table .summary-qty');
  if (summaryQtyElem) summaryQtyElem.textContent = packInput.value;
}

// document.addEventListener('variant:change', function() {
//   updateTotal();
// });

document.addEventListener('variant:changed', function (e) {
    updateVariantTitle(e.detail.variant.public_title || e.detail.variant.title);
    updateTotal();
});

function updateVariantTitle(variantValue) {
  const summaryElem = document.querySelector('.summaryVariant_title');
  if (summaryElem) summaryElem.textContent = variantValue;
}

function attachVariantListeners() {
  const radios = document.querySelectorAll('variant-selects [type="radio"]');
  radios.forEach(radio => {
    radio.removeEventListener('change', onVariantChange);
    radio.addEventListener('change', onVariantChange);
  });

  const checkedRadio = document.querySelector('variant-selects [type="radio"]:checked');
  if (checkedRadio) updateVariantTitle(checkedRadio.value);

  const inputs = document.querySelectorAll('input.product-pack-of-value, input[name="quantity"]');
  inputs.forEach(input => {
    input.removeEventListener('input', updateTotal);
    input.removeEventListener('change', updateTotal);
    input.addEventListener('input', updateTotal);
    input.addEventListener('change', updateTotal);
  });

  updateTotal();

  document.querySelectorAll('.oscpPriceGridContainer .oscp-price-grid-total-savings span, .oscp-price-grid-discounted, .f-price-item, .f-price-item s, .summaryVariant_price').forEach(el => {
    el.textContent = el.textContent.replace(/excl\.?\s*VAT/gi, '').trim();
  });
}

function onVariantChange(e) {
  updateVariantTitle(e.target.value);
  updateTotal();
}

attachVariantListeners();
document.addEventListener('cpw:price-grid-switch', attachVariantListeners);

// Fixed 2026-10-06: the product section re-renders its quantity input on a variant
// change, which drops the per-input listeners above, so properties[Total ...] stopped
// following the quantity. Listen at document level as well (updateTotal is idempotent).
['input', 'change'].forEach(function (type) {
  document.addEventListener(type, function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="quantity"]') && !e.target.closest('.sticky-atc-bar')) {
      try { updateTotal(); } catch (err) {}
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // The discounts app server-renders one .oscp-grid per variant on every page
  // load (all sharing the same duplicated id="oscpGridAccordion"), hides all
  // but the selected variant's via inline style, and never actually applies
  // the ".osc-active" class it defines CSS for — nothing in its script sets
  // it, and the tier radio only gets :checked when quantity exactly equals a
  // tier's minimum. So the old `.oscp-price-grid-list li.osc-active` lookup
  // (and its unscoped fallback to "the first .oscp-price-grid-item in the
  // whole document") could silently read another variant's price entirely.
  // Resolve the grid from the selected variant id instead, and pick the tier
  // ourselves by comparing each tier's data-qty threshold to the real quantity.
  function getActiveVariantGrid(variantId) {
    return variantId ? document.querySelector('.oscp-grid[data-variant-id="' + variantId + '"]') : null;
  }

  function getApplicableTierItem(grid, quantity) {
    const items = Array.from(grid.querySelectorAll('.oscp-price-grid-item'));
    if (!items.length) return null;
    return items.reduce((best, item) => {
      const tierQty = parseFloat(item.dataset.qty) || 0;
      if (tierQty <= quantity && (!best || tierQty > (parseFloat(best.dataset.qty) || 0))) {
        return item;
      }
      return best;
    }, null) || items[0];
  }

  function updateSummaryPrice() {
    const quantityInput = getMainQuantityInput();
    const quantity = parseFloat(quantityInput?.value) || 1;

    const grid = getActiveVariantGrid(getSelectedVariantId());
    const activeLi = grid ? getApplicableTierItem(grid, quantity) : null;
    if (!activeLi) return;

    // data-discounted-price is the app's raw rule value in pence, more
    // reliable than parsing the rendered "£1.63" text.
    const discountedPriceCents = parseFloat(activeLi.dataset.discountedPrice);
    const price = !isNaN(discountedPriceCents)
      ? discountedPriceCents / 100
      : parseFloat((activeLi.querySelector('.oscp-price-grid-discounted')?.textContent || '').replace(/[^\d.]/g, '')) || 0;

    const total = price * quantity;

    let currencySymbol = '£';
    if (window.Shopify && Shopify.currency) {
      if (Shopify.currency.symbol) {
        currencySymbol = Shopify.currency.symbol;
      } else if (Shopify.currency.active === 'USD') {
        currencySymbol = '$';
      }
    }

    document.querySelectorAll('.summaryVariant_price').forEach(el => {
      el.textContent = currencySymbol + total.toFixed(2);
    });

    document.querySelectorAll(
      '.product__info-container .f-price__sale .f-price-item.f-price-item--sale, ' +
      'sticky-atc-bar .f-price-item.f-price-item--sale, ' +
      '.product__info-container .f-price__regular .f-price-item--regular, ' +
      'sticky-atc-bar .f-price__regular .f-price-item--regular'
    ).forEach(el => {
      el.textContent = currencySymbol + total.toFixed(2);
    });

    if (typeof updateTotal === "function") {
      updateTotal();
    }
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest(".oscp-price-grid-list li")) {
      // .oscp-price-grid-list li
      setTimeout(updateSummaryPrice, 600);
    }
  });

  document.addEventListener("input", function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      updateSummaryPrice();
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      updateSummaryPrice();
    }
  });

  // The widget re-renders in place after a variant switch, so watch it
  // directly rather than guessing a fixed delay. Every variant's grid shares
  // the same duplicated id="oscpGridAccordion", so getElementById would only
  // ever see the first one (usually hidden) — observe every grid instead.
  document.querySelectorAll('.oscp-grid').forEach(function (grid) {
    const priceGridObserver = new MutationObserver(function () {
      updateSummaryPrice();
    });
    priceGridObserver.observe(grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-variant-id', 'style']
    });
  });

  document.addEventListener('variant:changed', function () {
    setTimeout(updateSummaryPrice, 600);
  });

  updateSummaryPrice();
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.addEventListener("change", function (e) {
//     if (e.target && e.target.name === "updates[]") {
//       const input = e.target;
//       const cartItem = input.closest(".cart-item");

//       if (!cartItem) return;

//       const variantId = cartItem.dataset.variantId;
//       const baseBags = parseInt(cartItem.dataset.totalBags) || 100;
//       const quantity = parseInt(input.value) || 0;
//       const total = baseBags * quantity;

//       console.log(`Variant ${variantId}: ${quantity} × ${baseBags} = ${total} bags`);

//       fetch(`/cart/change.js`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: quantity,
//           properties: {
//             "Total Bags": total.toString()
//           }
//         })
//       })
//         .then((res) => res.json())
//         .then((data) => console.log("Cart updated:", data))
//         .catch((err) => console.error("Error:", err));
//     }
//   });
// });